<template>
    
    <b-card no-body>
        <b-modal id="update" title="Güncelle" no-close-on-esc no-close-on-backdrop>
            <traffic-fine-update v-model="trafficFine"></traffic-fine-update>
            <template #modal-footer><v-executer :loading="loading" text="Güncelle" :action="update"></v-executer></template>
        </b-modal>

        <b-modal id="upload" size="lg" title="Excel Yükle" scrollable no-close-on-esc no-close-on-backdrop>
            <traffic-fine-upload-excel v-model="uploadObject"></traffic-fine-upload-excel>
            <b-alert v-if="uploadResultMessage" :variant="uploadResultVariant" show class="mt-1 mb-0">
                {{ uploadResultMessage }}
            </b-alert>
            <template #modal-footer><v-executer :loading="uploading" :action="upload" :disabled="!uploadObject.File">Yükle</v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    pagination="server"
                    search
                    initial-sort-by="StartDate" 
                    :initial-sort-desc=true
                    :items-provider="provider"
                    name="trafficFine"
                    :fields="fields"
                    :buttons="buttons">
                    <template #additional-actions>
                        <div class="row">
                            <div class="col-md-2">
                                <select class="form-control bg-img-none" v-model="year">
                                    <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                                </select>
                            </div>
                            <div class="col-auto">
                                <button class="btn btn-success" v-on:click="$refs.table.refresh()">Sorgula</button>
                            </div>
                            <div class="col-auto">
                                <button class="btn btn-secondary" v-on:click="uploadExcel">Excel Yükle</button>
                            </div>
                        </div>
                    </template>
        </v-table>
    </b-card>
</template>

<script>
import OperationalParametersApi from '@/api/operational-parameters'
import TrafficFineUpdate from './components/TrafficFineUpdate.vue'
import TrafficFineUploadExcel from './components/TrafficFineUploadExcel.vue'
import { BAlert, BCard } from 'bootstrap-vue'
import moment from 'moment'
import Additional from '@/utilities/additional'

export default {
    components:{
        BAlert,
        BCard,
        TrafficFineUpdate,
        TrafficFineUploadExcel
    },
    data(){
        return{
            years:[],
            year: moment().year(),
            fields:[
                {name:"Ceza",key:'Clause',thClass:'w-20'}, 
                {name:'Açıklama',key:'Description',thClass:'w-60'},
                {name:"Ceza Tutarı (TL)",key:'PriceStr',thClass:'w-20'}, 
                {name:"Ceza Puanı",key:'PointStr',thClass:'w-20'}, 
                {name:"Başlangıç Tarihi",key:'StartDateStr',thClass:'w-20'}, 
                {name:"Bitiş Tarihi",key:'EndDateStr',thClass:'w-20'}, 
                {name:"Değiştirilebilir",key:'IsCanChangablePrice'}, 
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
            ],
            loading:false,
            trafficFine:{
                Id:null,
                Clause:null,
                Description:null,
                IsCanChangablePrice:false,
                Price:0,
                PriceStr:"0,00",
                StartDate:"01.01.0001",
                StartDateStr:"01.01.0001",
                EndDate:null,
                EndDateStr:null
            },
            uploading:false,
            uploadResultMessage:null,
            uploadResultVariant:'danger',
            uploadObject:{
                File:null
            }
        }
    },
    mounted(){
        this.configureYears()
    },
    methods:{
        configureYears(){  
            let years = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 2023
            while (firstYear <= year){
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
        clearForm(){
            this.trafficFine.Id = null
            this.trafficFine.Clause = null
            this.trafficFine.Description = null
            this.trafficFine.IsCanChangablePrice = false
            this.trafficFine.Price = 0
            this.trafficFine.StartDate = null
            this.trafficFine.EndDate = null
        },
        provider(data){
            return OperationalParametersApi.TrafficFine.Table({...data,Year:this.year})
        },
        edit(item){
            this.clearForm()
            this.trafficFine.Id = item.Id
            this.trafficFine.Clause = item.Clause
            this.trafficFine.Description = item.Description
            this.trafficFine.IsCanChangablePrice = item.IsCanChangablePrice
            this.trafficFine.Price = item.Price
            this.trafficFine.PriceStr = item.PriceStr
            this.trafficFine.StartDate = item.StartDate
            this.trafficFine.StartDateStr = item.StartDateStr
            this.trafficFine.EndDate = item.EndDate
            this.trafficFine.EndDateStr = item.EndDateStr
            this.$showModal('update')
        },
        update(){
            this.loading = true
            OperationalParametersApi.TrafficFine.CreateOrUpdate(true,this.trafficFine).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('update')
                }
            }).catch(err=>{
                this.$result(res)
                this.loading = false
            })
        },
        uploadExcel(){
            this.uploadObject.File = null
            this.uploadResultMessage = null
            this.uploadResultVariant = 'danger'
            this.$showModal('upload')
        },
        async upload(){
            this.uploading = true
            this.uploadResultMessage = null
            this.uploadResultVariant = 'danger'
            let formData = await Additional.ToFormData(this.uploadObject,['File'])
            OperationalParametersApi.TrafficFine.Upload(formData).then(res => {
                this.uploadResultMessage = res.data.Message || (res.data.Success ? 'Excel başarıyla yüklendi.' : 'Excel yükleme işlemi başarısız oldu.')
                this.uploadResultVariant = res.data.Success ? 'success' : 'danger'
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('upload')
                }
                this.$result(res)
                this.uploading = false
            }).catch(err => {
                this.uploadResultMessage = (err.response && err.response.data && err.response.data.Message) || err.message || 'Excel yükleme sırasında beklenmeyen bir hata oluştu.'
                this.uploadResultVariant = 'danger'
                this.uploading = false
                this.$result(null,err)
            })
        }
    }
}
</script>

<style>

</style>
